export default {
  ADS_SCRIPT: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
}
